<script setup>
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref, watch, defineProps, defineEmits} from "vue";
import axios from "axios";

const props = defineProps({
    value: String,
    entity: String,
    load: Boolean,
    readonly: Boolean,
    label: String,
    workerCode: String,
    rules: Array,
});

const emit = defineEmits(['input']);

const {loading, inputColor, inputBackgroundColor} = useSharedData();

const code = ref(null);

function getCode() {
    loading.value = true;
    axios.get(`/codifications/entity/${props.entity}`).then(response => {
        code.value = response.data;
        emit('input', code.value);
    }).finally(() => {
        loading.value = false;
    });
}

const isEditable = ref(false);
const loadingEditable = ref(false);

function checkEditable() {
    loadingEditable.value = true;
    axios.get(`/codifications/isEditable/${props.entity}`).then(response => {
        isEditable.value = response.data;
    }).finally(() => {
        loadingEditable.value = false;
    });
}


watch(() => props.value, () => {
    if (!props.load) {
        code.value = props.value;
    }
}, {immediate: true});

watch(() => code.value, () => {
    emit("input", code.value);
});

onMounted(() => {
    checkEditable();
});

watch(() => props.load, () => {
    if (props.load) {
        getCode();
    }
}, {immediate: true});
</script>

<template>
    <div>
        <v-text-field
            v-model="code"
            :label="label"
            :loading="loading"
            outlined
            dense
            :readonly="isEditable ? readonly : true"
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :rules="rules"
            hide-details="auto"
            :append-icon="load ? 'mdi-reload' : null"
            @click:append="getCode"
        ></v-text-field>

        <input type="hidden">
    </div>
</template>